import { render, staticRenderFns } from "./card-simple-button.vue?vue&type=template&id=7d7a8b53&"
import script from "./card-simple-button.vue?vue&type=script&lang=js&"
export * from "./card-simple-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports